<div>
    <div class="uk-section uk-section-large uk-section-muted" style="padding-bottom: 40px;">
<div class="uk-container">


<div class="uk-grid-match uk-margin-large  uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid="true">


    <div>
         <h2>WebSoulLabs</h2>

        <p class="uk-text-justify"> Websoullabs is an international web & mobile app development company based in India. Also, we provide premium IT Services related to mobile app, web, enterprise and other trending technology to business globally.

</p>

    </div>
    <div >
        <h3>Useful Links</h3>
        <ul class="uk-list">
                <li><a class="uk-link-text" href="#">Home</a>
            </li>
                <li><a class="uk-link-text" href="aboutus">About Us</a>
            </li>
                <li><a class="uk-link-text" href="service-page">Services</a>
            </li>
                <li><a class="uk-link-text" href="career">Careers</a>
            </li>
                <li><a class="uk-link-text" href="https://websoullabsblog.000webhostapp.com/">Blogs</a>
            </li>
        </ul>

    </div>
        <div>
            <h3>Our Services</h3>

            <ul class="uk-list">
                    <li><a class="uk-link-text" href="web">Web Application Development</a>
                </li>
                    <li><a class="uk-link-text" href="mobile-application-development-page">Mobile Application Development</a>
                </li>
                    <li><a class="uk-link-text" href="ecommerce-page">E-Commerce Web Development</a>
                </li>
                    <li><a class="uk-link-text" href="digital-mart-page">Digital Marketing</a>
                </li>
                    <li><a class="uk-link-text" href="graphic">Graphic Design</a>
                </li>
            </ul>
    </div>
    <div>
        <h3>Contact US</h3>
        <ul class="uk-list">
                <li>14/291 K,Suite 75D,1st Floor
            </li>
                <li>A Square,Edathala P O,Kuzhivelippady
            </li>
                <li>Ernakulam,Kerala:683561
            </li>
                <li>Phone: +91-8848430565
            </li>
                <li>Email:  websoul467@gmail.com
            </li>
        </ul>

    </div>
</div>
</div>





</div>


    <div class=" uk-padding">
        <p class="uk-align-left" style="width: 350px; height: 30px; font-size: 13px;">Copyright © 2025 websoullabs. All Rights Reserved</p>


        <div class="uk-align-right" style="margin-left: 0px; margin-left: 0px; padding-right: 5px;">
            <a href="https://www.linkedin.com/company/web-soul" style="margin: 10px;"><span uk-icon="icon:   linkedin; ratio: 1"></span></a>
            <a href="https://www.facebook.com/Websoullabs-Private-Limited-110065700636451" style="margin: 10px;"><span uk-icon="icon:  facebook; ratio: 1"></span></a>
            <a href="https://instagram.com/websoul_labs?igshid=8bglslsy6i16" style="margin: 10px;"> <span uk-icon="icon:  instagram; ratio: 1"></span></a>
            <a  href="https://wa.me/<917356189747>" style="margin: 10px;"><span uk-icon="icon:  whatsapp; ratio: 1"></span></a>
            <a  href="https://twitter.com/websoullabs" style="margin: 10px;"><span uk-icon="icon:  twitter; ratio: 1"></span></a>


        </div>
    </div>

</div>
